import React, { useContext, useMemo } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { clientTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from 'components/Icon/Icon';
import { OutsideFormSelectNew } from 'components/Select/OutsideFormSelectNew';

const clientTypeIcons: Record<string, IconName> = {
	clientTypeHotels: IconName.clientTypeHotels,
	clientTypeRestaurants: IconName.clientTypeRestaurants,
	clientTypeFastFood: IconName.clientTypeFastFood,
};

export const ClientTypeSelect: React.FC = () => {
	const { setClientType, selectedClientType } = useContext<ICustomersContext>(CustomersContext);
	const { t } = useTranslation('listing');

	const options = useMemo(
		() => [
			{
				id: null,
				name: t('clientTypeAll'),
				icon: <Icon name={IconName.clientTypeAll} size="lg" className="text-purple-07-new" />,
			},
			...clientTypes.map((clientType) => ({
				id: clientType.clientTypeID,
				name: t(clientType.clientTypeName),
				icon: (
					<Icon name={clientTypeIcons[clientType.clientTypeName]} size="lg" className="text-purple-07-new" />
				),
			})),
		],
		[t],
	);

	return (
		<OutsideFormSelectNew
			testId="ClientTypeSelect"
			name="ClientTypeSelect"
			label="clientTypeLabel"
			onChange={setClientType}
			value={selectedClientType}
			options={options}
			listItemHeight={options.length}
			withSearch={false}
			allowClear={false}
			withValidation={false}
			withEmptyOption={false}
		/>
	);
};
